import ceas11 from '../../../assets/images/ceas11.png';
import ceas22 from '../../../assets/images/ceas22.png';
import ceas33 from '../../../assets/images/ceas33.png';
import ceas44 from '../../../assets/images/ceas44.png';
import ceas55 from '../../../assets/images/ceas55.png';
import ceas66 from '../../../assets/images/ceas66.png';

export default function CasesSection() {
  const cases = [
    {
      title: '上海市奉贤区奉城老街雨污混接改造工程',
      category: '真空负压',
      description: '上海市首个大规模应用负压收集系统的雨污分流工程项目，聚焦老街雨污合流、污水直排河道、道路破损等顽疾，深度融合老旧街巷改造与水环境治理，成为上海城市更新中的典范案例。',
      image: ceas11,
      results: ['新建7套生活污水负压收集系统，敷设污水管道2.9万米，改造147个入河排放口',
        '彻底解决雨污混接与旱天污水直排河问题，实现水环境与民生品质双提升',
        '相较于重力排水系统，施工成本降低55%，运维成本降低40%']
    },
    {
      title: '上海市青浦区朱家角古镇水系清澈度提升工程',
      category: '河湖治理',
      description: '为助力上海朱家角古镇创建国家5A级景区所开展的水环境综合整治工程。工程着眼优化区域生态脉络，通过系统性治理和创新方式，显著提升了水体健康水平与环境承载能力，区域生态品质实现跃升。',
      image: ceas22,
      results: ['水系清澈度提升，近岸水体清澈见底，深水区清澈度达到1.5m',
        '水质保障长期达标，保持Ⅲ～IV类水质，河长制考核断面稳定达标',
        '通过智慧手段，实现传统古镇水环境现代化、智慧化、数字化管理']
    },
    {
      title: '上海市浦东新区污水泵站水质在线监测项目',
      category: '环境监测',
      description: '通过在污水泵站布设国标法的微型水质自动监测站，构建了覆盖关键节点的7x24小时水质监测网络，破解了雨污混流实时预警与排水系统智能化管理的难题，是智慧排水“源-网-站-厂-河”一体化模式中的典范实践。',
      image: ceas33,
      results: ['为城市污水系统提供COD、氨氮、总磷等指标24小时不间断监测服务',
        '实现排水系统智慧化，“源-网-站-厂-河”管理一体化',
        '为排水部门提供防汛排涝决策水质变化数据']
    },
    {
      title: '上海市奉贤区排水系统一网统管',
      category: '管网服务',
      description: '通过智慧流向仪硬件，构建了高效的管网溯源排查与长效监管体系，实现了对城市涉水基础设施的智能感知和精准诊断，是智慧水务建设中低成本高效管理的典范案例。',
      image: ceas44,
      results: ['长效监管', '实现排水系统智慧化，“源-网-站-厂-河”管理一体化', '为排水部门提供防汛排涝决策水质变化数据']
    },
    {
      title: '上海中金所技术研发基地排水管家服务项目',
      category: '排水管家',
      description: '针对上海中金所技术研发基地提供日常清理及抢修服务，保障基地排水管道均能畅通无阻，设施设备处于良好使用状态，排放污水水质达到上海浦东新区水务监测规定排放标准。',
      image: ceas55,
      results: ['保障基地排水系统稳定运行', '保证基地污水排放标准达标', '为基地提供24小时全天候排水系统抢修服务']
    },
    {
      title: '上海白龙港一体化MBR污水处理项目',
      category: '水处理设备',
      description: '针对上海白龙港地区居民生活污水直排问题，万江环境采用埋地式MBR污水处理设备对其进行收集处理，水质达标后排入河道，共有700多户居民的生活污水问题因此得到解决。',
      image: ceas66,
      results: ['污水经处理后全部达到Ⅳ类水标准', '700多户居民的生活污水问题得到解决']
    }
  ];

  return (
    <section id="cases" className="py-8 md:py-16 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* 标题区：动态缩放，保持层级比例 */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-gray-900 mb-6">
            部分项目案例
          </h2>
          <p className="text-[clamp(0.875rem,1.5vw,1.125rem)] text-gray-600 max-w-3xl mx-auto leading-relaxed">
            作为深耕水环境领域的解决方案专家，万江环境凭借自身“六位一体”发展战略，以“规划+产品+技术+落地”为解决路径，最终为用户提供全周期解决方案
          </p>
        </div>

        {/* 案例卡片区：全元素响应式缩放，图片保持比例不裁剪 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-[clamp(1.5rem,3vw,2rem)]">
          {cases.map((caseItem, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              {/* 案例图片区：高度随宽度缩放，图片完整显示不裁剪 */}
              <div className="relative">
                <div className="bg-gray-100">
                  <img
                    src={caseItem.image}
                    alt={caseItem.title}
                    className="w-full h-[clamp(180px,30vw,300px)] object-cover" // 高度随宽度30%缩放，避免裁剪
                    style={{ objectFit: 'cover' }} // 保持图片填充容器，按比例裁剪边缘（如需完整显示可改为object-contain）
                  />
                </div>
                {/* 分类标签：尺寸随屏幕缩放 */}
                <div className="absolute top-[clamp(0.75rem,1.5vw,1rem)] left-[clamp(0.75rem,1.5vw,1rem)]">
                  <span className="bg-blue-600 text-white px-[clamp(0.5rem,1vw,0.75rem)] py-[clamp(0.25rem,0.5vw,0.5rem)] rounded-full text-[clamp(0.75rem,1.2vw,0.875rem)] font-medium">
                    {caseItem.category}
                  </span>
                </div>
              </div>

              {/* 案例内容区：内边距和文字动态缩放 */}
              <div className="p-[clamp(1.25rem,2.5vw,2rem)]">
                <h3 className="text-[clamp(1rem,2vw,1.25rem)] font-bold text-gray-900 mb-[clamp(1rem,1.5vw,1.5rem)] line-clamp-2">
                  {caseItem.title}
                </h3>
                <p className="text-gray-600 mb-[clamp(1rem,1.5vw,1.5rem)] leading-relaxed text-[clamp(0.8125rem,1.2vw,0.875rem)]">
                  {caseItem.description}
                </p>

                {/* 项目成果列表：图标与文字同步缩放 */}
                <div className="space-y-[clamp(0.5rem,1vw,0.75rem)]">
                  <h4 className="font-semibold text-gray-900 mb-[clamp(0.75rem,1.2vw,1rem)] text-[clamp(0.875rem,1.4vw,1rem)]">
                    项目成果：
                  </h4>
                  {caseItem.results.map((result, resultIndex) => (
                    <div key={resultIndex} className="flex items-center space-x-[clamp(0.5rem,1vw,0.75rem)]">
                      {/* 成果图标：尺寸随屏幕缩放，保持圆形 */}
                      <div className="w-[clamp(1rem,2vw,1.25rem)] h-[clamp(1rem,2vw,1.25rem)] bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-line text-blue-600 text-[clamp(0.625rem,1vw,0.75rem)]"></i>
                      </div>
                      <span className="text-gray-700 text-[clamp(0.8125rem,1.2vw,0.875rem)]">
                        {result}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 底部咨询区块：整体缩放，保持视觉重心 */}
        <div className="text-center mt-[clamp(2rem,4vw,4rem)]">
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-3xl p-[clamp(1.5rem,3vw,2.5rem)] text-white mx-auto">
            <h3 className="text-[clamp(1.25rem,2.5vw,1.75rem)] font-bold mb-[clamp(1rem,2vw,1.5rem)]">
              让我们一起创造更多成功案例
            </h3>
            <p className="text-[clamp(0.875rem,1.5vw,1.125rem)] mb-[clamp(1.25rem,2.5vw,2rem)] opacity-90">
              无论您面临什么样的水环境挑战，我们都有信心为您提供最佳解决方案
            </p>
            <button
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-white text-blue-600 px-[clamp(1.5rem,3vw,2rem)] py-[clamp(0.75rem,1.5vw,1rem)] rounded-lg text-[clamp(0.875rem,1.5vw,1rem)] font-bold hover:bg-gray-100  whitespace-nowrap cursor-pointer transition-all duration-300 hover:-translate-y-2"
            >
              立即咨询
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}